import { useStore } from "../store";

export const useUi = () => {
  const { state, updateState } = useStore("ui", {});
  return {
    ui: state,
    updateUi: updateState,
  };
};
